import qs from 'qs';

// DEPRECATED
// Use useSearchParams instead as it's the official way for react-router
const useQuery = () => qs.parse(window.location.search, { ignoreQueryPrefix: true });

export default useQuery;
